import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import StyledSlider from 'Components/UI/StyledSlider';
import withStyles from '@material-ui/core/styles/withStyles';
import ProgressSliderValue from './ProgressSliderValue';

const styles = () => ({
  root: {},
});

const ProgressSlider = ({ className, classes, value }) => {
  return (
    <StyledSlider
      className={classNames(classes.root, className)}
      ValueLabelComponent={ProgressSliderValue}
      value={value}
      valueLabelDisplay="on"
      disabled
    />
  );
};

ProgressSlider.defaultProps = {
  className: '',
};

ProgressSlider.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  value: PropTypes.number.isRequired,
};

export default withStyles(styles)(ProgressSlider);
